<template>
    <div class="shadow overflow-hidden">
        <div>
            <dl>
                <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctime.programme_name') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctime.programme_name }}
                    </dd>
                </div>

                <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctime.description') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctime.description }}
                    </dd>
                </div>

                <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctime.remarks') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctime.remarks }}
                    </dd>
                </div>

                <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctime.start_date') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctime.start_date }}
                    </dd>
                </div>

                <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctime.end_date') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctime.end_date }}
                    </dd>
                </div>

                <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctime.start_work_time') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctime.start_work_time }}
                    </dd>
                </div>

                <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctime.end_work_time') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctime.end_work_time }}
                    </dd>
                </div>

                <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctime.consider_as_time') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctime.consider_as_overtime ? 'Yes' : 'No' }}
                    </dd>
                </div>

                <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctime.created_by') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctime.created_by }}
                    </dd>
                </div>

                <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctime.updated_by') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctime.updated_by }}
                    </dd>
                </div>

                <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctime.created_at') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctime.created_at }}
                    </dd>
                </div>

                <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctime.updated_at') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctime.updated_at }}
                    </dd>
                </div>
            </dl>

            <div>
                <main-section>
                    <Progexctimecomm :propClass="progexctime" :programmeExceptionTimeId="progexctime.id" />
                </main-section>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { ref, reactive, watchEffect } from 'vue'
import Progexctimecomm from '@/views/humanresource/programmeexceptiontimecommitee/Index.vue'

export default {
    name: 'Programme Exception Time Detail',
    components: {
        Progexctimecomm
    },
    props: {
        propClass: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['close-modal', 'submit'],
    setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Details'])

        const progexctime = reactive({
            id: '',
            programme_id: '',
            programme_name: '',
            description: '',
            remarks: '',
            start_date: '',
            end_date: '',
            start_work_time: '',
            end_work_time: '',
            consider_as_overtime: false,
            created_by: '',
            updated_by: '',
            created_at: '',
            updated_at: ''
        })

        watchEffect(() => {
            const newProgexctime = props.propClass
            // Object.assign(progexctime, newProgexctime)

            if (newProgexctime && Object.keys(newProgexctime).length > 0) {
                Object.assign(progexctime, newProgexctime)
            }
        })

        return {
            titleStack,
            progexctime
        }
    }
}
</script>